import { QuestionsMode } from "../types";
import QuestionsPage from "./questions/QuestionsPage";
export default function QuestionsSpecificRoute() {
  const mode: QuestionsMode = { kind: "specific" };
  return <QuestionsPage mode={mode} />;
}
